import * as React from "react"
import { PlaylistInteractionContext } from "./PlaylistInteractionContext.tsx"

export const usePlaylistInteraction = () => {
  const context = React.use(PlaylistInteractionContext)
  if (!context) {
    throw new Error("usePlaylistInteraction must be used within an PlaylistInteractionProvider")
  }
  return context
}
